import {
  ADICIONAR_FILTRO_CENTRO_CUSTO, LIMPAR_FILTRO_CENTRO_CUSTO,
  REMOVER_FILTRO_CENTRO_CUSTO,
} from '../../actions/types'
  import { filtroExiste } from '../../util/filtros'

  const initialState = undefined

  export const filtrosAdicionadosCentroCusto = (state = [], action = initialState) => {
    switch (action.type) {
      case ADICIONAR_FILTRO_CENTRO_CUSTO: {
        if (!filtroExiste(state, action.payload)) {
          return state.concat(action.payload)
        }
        return state
      }

      case REMOVER_FILTRO_CENTRO_CUSTO: {
        const copia = [...state]
        return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
      }

      case LIMPAR_FILTRO_CENTRO_CUSTO: {
        return []
      }

      default:
        return state
    }
  }
